module.exports = __webpack_public_path__ + "img/Mb_MiddleSide_right.e8f39cc2.jpg";